// `syto.` wordmark — the `o` is a kcal-progress ring (the product literally
// encoded in the mark). See design_handoff_sytofood/brand.jsx → SytoLogo.

type Props = {
  size?: number;
  ringPct?: number;
  className?: string;
  // Override the wordmark colour. Defaults to var(--ink); ADHD variant B
  // passes its palette ink so the logo stays legible on the `stop` bg.
  color?: string;
};

export function SytoLogo({
  size = 24,
  className,
  color,
}: Pick<Props, "size" | "className" | "color">) {
  return (
    <span
      className={className}
      style={{
        fontFamily: "var(--font-display)",
        fontSize: size,
        fontWeight: 800,
        letterSpacing: "-0.05em",
        color: color ?? "var(--ink)",
        lineHeight: 1,
        display: "inline-flex",
        alignItems: "baseline",
      }}
    >
      syto
      <span style={{ color: "var(--accent)", fontWeight: 900 }}>.</span>
    </span>
  );
}

// Full-resolution ring variant for marketing / favicons / app icons.
export function SytoRingMark({ size = 64, ringPct = 0.72 }: Props) {
  const r = 23;
  const c = 2 * Math.PI * r;
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <circle
        cx="32"
        cy="32"
        r={r}
        fill="none"
        stroke="var(--track)"
        strokeOpacity="0.4"
        strokeWidth="12"
      />
      <circle
        cx="32"
        cy="32"
        r={r}
        fill="none"
        stroke="var(--accent)"
        strokeWidth="12"
        strokeLinecap="round"
        strokeDasharray={c}
        strokeDashoffset={c * (1 - ringPct)}
        transform="rotate(-90 32 32)"
      />
      <circle cx="50" cy="42" r="9" fill="var(--accent)" />
    </svg>
  );
}
